import { StyledFAQUl } from "../FAQ/FAQ";

export default function Home() {
  return (
    <h1>BLOG</h1>
  );
}
